import { Phone, MessageSquare, Sparkles } from "lucide-react";
import { BUSINESS_PHONE, BUSINESS_PHONE_FORMATTED, OWNER_FIRST_NAME } from "@/lib/constants";

export default function JeffreyIntro() {
    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 py-14" data-testid="jeffrey-intro">
            <div className="card-surface p-6 sm:p-10 grid lg:grid-cols-12 gap-6 items-center">
                <div className="lg:col-span-8">
                    <span className="chip"><Sparkles className="w-3 h-3" /> Hi, I'm {OWNER_FIRST_NAME}</span>
                    <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-white">
                        Real human help from <span className="accent-gradient-text">a Texan who cares.</span>
                    </h2>
                    <p className="mt-3 text-slate-300 leading-relaxed max-w-2xl text-sm sm:text-base">
                        I'm an independent representative based in Houston. I don't work for any
                        single provider - I help neighbors, families, and small-business owners
                        see what's really available in their area so they stop overpaying for
                        light, phone, and the services that quietly eat your paycheck.
                    </p>
                    <ul className="mt-5 grid sm:grid-cols-2 gap-2 text-sm text-slate-300">
                        {[
                            "No deposit options available",
                            "No contracts (if that's what you want)",
                            "Fast & secure switch process",
                            "Same reliable utility delivery",
                        ].map((b) => (
                            <li key={b} className="flex items-start gap-2">
                                <span className="w-5 h-5 mt-0.5 rounded-full bg-emerald-500/20 border border-emerald-500/40 inline-flex items-center justify-center text-emerald-300 text-xs">✓</span>
                                {b}
                            </li>
                        ))}
                    </ul>
                    <div className="mt-6 flex flex-wrap gap-3">
                        <a href={`tel:${BUSINESS_PHONE}`} className="btn-primary" data-testid="jeffrey-call-cta">
                            <Phone className="w-4 h-4" /> Call {BUSINESS_PHONE_FORMATTED}
                        </a>
                        <a href={`sms:${BUSINESS_PHONE}?&body=Hi Jeffrey, text me my options.`} className="btn-ghost" data-testid="jeffrey-text-cta">
                            <MessageSquare className="w-4 h-4" /> Text me your options
                        </a>
                    </div>
                </div>
                <div className="lg:col-span-4">
                    <div className="rounded-2xl p-6 border border-emerald-500/30 bg-emerald-500/5 relative overflow-hidden">
                        <div className="absolute -right-6 -top-6 w-32 h-32 bg-emerald-500/15 blur-2xl rounded-full" />
                        <div className="relative">
                            <div className="text-xs text-emerald-200/80 mono uppercase tracking-widest">Signed</div>
                            <div className="mt-2 text-4xl font-black italic" style={{ fontFamily: "'Outfit', cursive" }}>
                                — {OWNER_FIRST_NAME}
                            </div>
                            <p className="mt-3 text-xs text-slate-300 leading-relaxed">
                                Energy for a brighter tomorrow. Independent representative, Texas.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
